var _ = (typeof window !== "undefined" ? window['_'] : typeof global !== "undefined" ? global['_'] : null);
module.exports = function(data){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
__p+='<h4>From the <em>Handbook</em></h4>\n<p>You will also find content related to your search terms in the <em>Handbook</em>. Numbers in <em>italic</em> are section references.</p>\n<div id="book-refs"></div>\n';
return __p;
};
